import type { FonteLegale } from "../fonti-legali";

export const fontiLegaliFixtures: FonteLegale[] = [
  {
    id: "codice-contratti-esempio",
    titolo: "Codice degli appalti — edizione dimostrativa",
    categoria: "Normativa",
    descrizione: "Raccolta fittizia di principi per orientarsi nella revisione di procedure di affidamento.",
    estratto: "Le procedure sono organizzate secondo criteri di trasparenza, proporzionalità e tracciabilità.",
    aggiornatoIl: "12 ottobre 2026",
  },
  {
    id: "massimario-alfa",
    titolo: "Massimario Alfa — clausole di fornitura",
    categoria: "Giurisprudenza",
    descrizione: "Massime simulate utili a confrontare responsabilità, termini e rimedi nei contratti commerciali.",
    estratto: "La chiarezza della clausola contribuisce a definire l'ambito degli obblighi tra le parti.",
    aggiornatoIl: "8 ottobre 2026",
  },
  {
    id: "nota-procedura-futura",
    titolo: "Nota operativa Futura — verifica documentale",
    categoria: "Prassi",
    descrizione: "Scheda di lavoro fittizia con controlli preliminari per una pratica dello studio.",
    estratto: "Prima della firma, verificare soggetti, poteri di rappresentanza, allegati e data di efficacia.",
    aggiornatoIl: "2 ottobre 2026",
  },
];
